export default __webpack_public_path__ + "static/media/charm-5.b129260f.png";